import { FormEvent } from 'react'
import { Grid, H } from '@farewill/ui'
import { useFormikContext } from 'formik'

import { Input, SelectInput } from 'components/form'
import ContactEmailInput from 'components/form/contact-email-input'
import { Selected } from 'components/form/select-input/types'
import { MergeWarningForLeadPage as MergeWarning } from 'components/merge-warning'
import { LeadAttributes } from 'lib/models/lead'
import { SelectOptions } from 'lib/types/common'
import {
  PRODUCTS,
  LEAD_SOURCE_TYPE_OPTIONS,
  LEAD_SOURCE_IDENTIFIER_OPTIONS,
  LEAD_SOURCE_IDENTIFIERS,
} from 'utils/enums'

import { useLeadContext } from '../context'
import PartnersAndDiscounts from '../partners-and-discounts'

const CallerDetails = (): React.ReactElement => {
  const {
    updateContact,
    updateContactMeta,
    lead: { attributes },
  } = useLeadContext()
  const { handleSubmit, values, setFieldValue } =
    useFormikContext<LeadAttributes>()

  const sourceIdentifierOptions: SelectOptions = attributes.funeralPlanId
    ? [
        {
          value: LEAD_SOURCE_IDENTIFIERS.funeral_plan_redemption,
          label: 'Funeral plan redemption',
        },
      ]
    : LEAD_SOURCE_IDENTIFIER_OPTIONS[
        values.sourceType as keyof typeof LEAD_SOURCE_IDENTIFIER_OPTIONS
      ]

  const resetSourceIdentifierAndSubmit = (value: {
    name: string
    value: Selected
  }) => {
    setFieldValue('sourceIdentifier', null)
    handleSubmit(value as unknown as FormEvent<HTMLFormElement>)
  }

  return (
    <Grid data-scroll-id="keyInfo">
      <Grid.Item>
        <H size="S">The caller</H>
      </Grid.Item>
      <Grid.Item spanFromL={2}>
        <Input label="Title" name="contact.title" handleSave={updateContact} />
      </Grid.Item>
      <Grid.Item spanFromL={4}>
        <Input
          label="First name"
          name="contact.firstName"
          handleSave={updateContact}
          allowCopyToClipboard
        />
      </Grid.Item>
      <Grid.Item spanFromL={6}>
        <Input
          label="Last name"
          name="contact.lastName"
          handleSave={updateContact}
          allowCopyToClipboard
        />
      </Grid.Item>
      <Grid.Item spanFromL={6}>
        <Input
          label="Phone number"
          name="contact.phoneNumber"
          handleSave={updateContact}
          allowCopyToClipboard
        />
      </Grid.Item>
      <Grid.Item spanFromL={6}>
        <ContactEmailInput
          contactId={values.contact.id}
          handleSave={async ({ name, value }) => {
            await updateContact({ name, value })
          }}
          hasRelatedAccount={!!values.contact.accountUuid}
          inputName="contact.email"
          allowCopyToClipboard
        />
        <MergeWarning apiMessages={updateContactMeta?.messages} />
      </Grid.Item>
      <Grid.Item spanFromL={6}>
        <SelectInput
          label="Lead Type"
          name="sourceType"
          handleSave={resetSourceIdentifierAndSubmit}
          options={LEAD_SOURCE_TYPE_OPTIONS}
        />
      </Grid.Item>
      {sourceIdentifierOptions && (
        <Grid.Item spanFromL={6}>
          <SelectInput
            label="Source"
            name="sourceIdentifier"
            options={sourceIdentifierOptions}
            handleSave={() => handleSubmit()}
          />
        </Grid.Item>
      )}
      <Grid.Item>
        <PartnersAndDiscounts product={PRODUCTS.FUNERAL} />
      </Grid.Item>
    </Grid>
  )
}

export default CallerDetails
